"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BidderAdUnitsResolver = void 0;
//ANGULAR2 BITS
const core_1 = require("@angular/core");
//INTERNAL LIBRARY BITS
const bidder_service_1 = require("./bidder.service");
let BidderAdUnitsResolver = class BidderAdUnitsResolver {
    constructor(_bidder) {
        this._bidder = _bidder;
    }
    resolve() {
        return Promise.resolve(this._bidder.fetchBidderAdUnitGroups());
    }
};
exports.BidderAdUnitsResolver = BidderAdUnitsResolver;
exports.BidderAdUnitsResolver = BidderAdUnitsResolver = __decorate([
    (0, core_1.Injectable)(),
    __metadata("design:paramtypes", [bidder_service_1.BidderService])
], BidderAdUnitsResolver);
//# sourceMappingURL=bidder-adUnits.resolver.js.map